import React, { useState } from 'react';

import makeStyles from '@mui/styles/makeStyles';
import PlayIcon from '@mui/icons-material/PlayArrow';

import CrmButton from './CrmButton';
import { createStdRequest, apiFetch } from '../utils/utils';

const makeLocalStyles = makeStyles((theme) => ({
  player: {
    marginLeft: '-116px',
    transform: 'scale(0.7)',
  },
  arrowIcon: {
    display: 'inline-block',
    transform: 'translateY(6px) scale(1.0, 0.8)',
  },
  errorNotice: {
    color: 'red',
    fontWeight: 600,
    padding: '21px 8px',
  },
}));

const playCall = (firmId, callId, redirectUri, setPlaying, setMp3Uri, setErrorStatus) => {
  if (redirectUri.indexOf('access_key') > 0) {
    setMp3Uri(redirectUri);
    setPlaying(true);
  } else {
    setMp3UriForHipaaCallAndPlayIt(firmId, callId, setMp3Uri, setPlaying, setErrorStatus);
  }
};

const setMp3UriForHipaaCallAndPlayIt = (firmId, callId, setMp3Uri, setPlaying, setErrorStatus) => {
  const companyInfoUri = `/api/callRail/firm/${firmId}/apiKeyAndAccountId`;
  const actionOnGoodResponseToCompanyInfo = (json) => {
    const { apiKey, accountId } = json;
    console.log(`Returned with apiKey '${apiKey}' and accountId '${accountId}'`);
    const callRailApiUri = `https://api.callrail.com/v3/a/${accountId}/calls/${callId}/recording.json`;

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Token token=${apiKey}`);
    const rqProps = {
      method: 'GET',
      headers: myHeaders,
    };
    const callRailApiRq = new Request(callRailApiUri, rqProps);
    console.log(`Calling ${callRailApiUri} to get address of (temp) MP3 recording`);
    fetch(callRailApiRq)
      .then((responseObj) => {
        if (responseObj.ok) {
          const callRailApiRqResponseJson = responseObj.json();
          console.log(`Returned OK with body: ${JSON.stringify(callRailApiRqResponseJson)}`);
          return callRailApiRqResponseJson;
        } else {
          const responseStatus = responseObj.status;
          console.log(`Call to ${callRailApiUri} returned Error. StatusCode: ${responseStatus}`);
          setErrorStatus(responseStatus);
        }
      })
      .then((parsedJson) => {
        if (parsedJson) {
          console.log(`parsedJson: ${JSON.stringify(parsedJson)}`);
          const mp3Url = parsedJson.url;
          setMp3Uri(mp3Url);
          setPlaying(true);
        }
      });
  };

  const companyInfoRequest = createStdRequest(companyInfoUri);
  console.log(`Calling ${companyInfoUri}`);
  apiFetch(null, companyInfoRequest, actionOnGoodResponseToCompanyInfo);
};

const CallRailPlayerWidget = ({ firmId, crCallId, redirectUri }) => {
  const [playing, setPlaying] = useState(false);
  const [mp3Uri, setMp3Uri] = useState(null);
  const [errorStatus, setErrorStatus] = useState(0);

  if (!redirectUri) {
    return null;
  }

  const myStyles = makeLocalStyles();

  if (playing) {
    return (
      <div className={myStyles.player}>
        <audio controls autoPlay src={mp3Uri} type="audio/mp3" />
      </div>
    );
  } else if (errorStatus > 0) {
    if (errorStatus == 401) {
      return <div className={myStyles.errorNotice}>Error: Unauthenticated</div>;
    } else if (errorStatus == 403) {
      return <div className={myStyles.errorNotice}>Error: Unauthorized</div>;
    } else if (errorStatus == 404) {
      return <div className={myStyles.errorNotice}>Error: Not Found</div>;
    } else if (errorStatus == 500) {
      return <div className={myStyles.errorNotice}>Internal Server Error</div>;
    } else if (errorStatus == 502) {
      return <div className={myStyles.errorNotice}>Error: Bad Gateway</div>;
    } else {
      return <div className={myStyles.errorNotice}>Error: Unknown</div>;
    }
  } else {
    return (
      <CrmButton filled onClick={() => playCall(firmId, crCallId, redirectUri, setPlaying, setMp3Uri, setErrorStatus)}>
        Play
        <div className={myStyles.arrowIcon}>
          <PlayIcon />
        </div>
      </CrmButton>
    );
  }
};

export default CallRailPlayerWidget;
